import { render, staticRenderFns } from "./ResultCheckContent.vue?vue&type=template&id=1a8c9090&scoped=true"
import script from "./ResultCheckContent.vue?vue&type=script&lang=js"
export * from "./ResultCheckContent.vue?vue&type=script&lang=js"
import style0 from "./ResultCheckContent.vue?vue&type=style&index=0&id=1a8c9090&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8c9090",
  null
  
)

export default component.exports